

function initAutocompleteCheckPage() {
    var autocomplete1
    if (document.getElementById("searchCoverage")) {
        (autocomplete1 = new google.maps.places.Autocomplete(document.getElementById("searchCoverage"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillInAddress(autocomplete1); });
        var element = document.querySelector('button.check-button-search');

        if (element != null) {
            document.querySelector('button.check-button-search').addEventListener("click", function () { fillInAddress(autocomplete1) });

            document.querySelector('button.check-button-search').addEventListener("keypressed", function () {
                if (characterCode == 13) {
                    fillInAddress(autocomplete2);
                    return false; // returning false will prevent the event from bubbling up.
                }
                else {
                    return true;
                }
            });
        }
    }
}

function initAutocompleteCheckPage2() {
    var autocomplete1;
    if (document.getElementById("searchCoverage")) {
        (autocomplete1 = new google.maps.places.Autocomplete(document.getElementById("searchCoverage"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillInAddress(autocomplete1); });
        var element = document.querySelector('button.coverage-search-button');

        if (element != null) {
            document.querySelector('button.coverage-search-button').addEventListener("click", function () { fillInAddress(autocomplete1) });

            document.querySelector('button.coverage-search-button').addEventListener("keypressed", function () {
                if (characterCode == 13) {
                    fillInAddress(autocomplete2);
                    return false; // returning false will prevent the event from bubbling up.
                }
                else {
                    return true;
                }
            });
        }
    }
}

function initAutocompleteTaranaInterestPage() {
    var autocomplete1;

    (autocomplete1 = new google.maps.places.Autocomplete(document.getElementById("searchStreet"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillTaranaInterestAddress(autocomplete1); });

    //document.querySelector('button.coverage-search-button').addEventListener("click", function () { fillInAddress(autocomplete1) });

    //document.querySelector('button.coverage-search-button').addEventListener("keypressed", function () {
    //    if (characterCode == 13) {
    //        fillInAddress(autocomplete1);
    //        return false; // returning false will prevent the event from bubbling up.
    //    }
    //    else {
    //        return true;
    //    }
    //});
}


function initAutocompleteVumaReachPage() {
    var autocomplete1;

    (autocomplete1 = new google.maps.places.Autocomplete(document.getElementById("searchStreet"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillInAddress(autocomplete1); });

    document.querySelector('button.coverage-search-button').addEventListener("click", function () { fillInAddress(autocomplete1) });

    document.querySelector('button.coverage-search-button').addEventListener("keypressed", function () {
        if (characterCode == 13) {
            fillInAddress(autocomplete1);
            return false; // returning false will prevent the event from bubbling up.
        }
        else {
            return true;
        }
    });
}

function initAutocompleteHomePage() {
    var autocomplete1, autocomplete2;

    (autocomplete1 = new google.maps.places.Autocomplete(document.getElementById("searchStreet"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillInAddress(autocomplete1); });

    document.querySelector('button.coverage-search-button').addEventListener("click", function () { fillInAddress(autocomplete1) });

    document.querySelector('button.coverage-search-button').addEventListener("keypressed", function () {
        if (characterCode == 13) {
            fillInAddress(autocomplete1);
            return false; // returning false will prevent the event from bubbling up.
        }
        else {
            return true;
        }
    });

    (autocomplete2 = new google.maps.places.Autocomplete(document.getElementById("searchCoverage"), { componentRestrictions: { country: "za" } })).addListener("place_changed", function () { fillInAddress(autocomplete2); });
    document.querySelector('button.check-button-search').addEventListener("click", function () { fillInAddress(autocomplete2) });

    document.querySelector('button.check-button-search').addEventListener("keypressed", function () {
        if (characterCode == 13) {
            fillInAddress(autocomplete2);
            return false; // returning false will prevent the event from bubbling up.
        }
        else {
            return true;
        }
    });
}

function fillInAddress(autocomplete) {
    autocomplete.getPlace();
    Redirect(autocomplete);
}

function Redirect(autocomplete) {
    var e = autocomplete.getPlace();
    var pId = GetParameterValues("pId"); // could be "product id" if coming from e.g. FLTE, or Promo Id if coming from social media link
    if (pId === undefined)
        pId = sessionStorage["pId"]; // URL will override, but if it's not set, check if an existing sessionStorage value exists, and use that
    let cbState = pId ? ("&cbState=" + pId) : "";
    window.location.href = "/coverage/map/" + (typeof (e) != 'undefined' && e.geometry ? "?lat=" + e.geometry.location.lat() + "&lng=" + e.geometry.location.lng() : "") + cbState;
}
